// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f1633b57","248":"fc98a38d","319":"22a79653","364":"100919fd","471":"a1849497","499":"5f06b4b5","566":"b1cd59a5","583":"1b441518","756":"e57ec7c6","895":"de1cb01c","907":"1843989f","983":"e9db190b"}[chunkId] + ".chunk.js";
};